import Plans from './Plans'
import LeaPlans from './LeaPlans'
import LeaPayment from './LeaPayment'

export default [{
  path: '/plans',
  name: 'Plans',
  component: Plans,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'Plans'}
}, {
  path: '/plans/lea',
  name: 'LeaPlans',
  component: LeaPlans,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'LEA subscription plans'}
}, {
  path: '/plans/lea/payment/:role',
  name: 'LeaPayment',
  component: LeaPayment,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'LEA subscription plans'}
}]



// WEBPACK FOOTER //
// ./src/pages/plan/router.js